import React, { useState } from "react";
import LibrarySong from "./LibrarySong";

export default function Library({
  renderLibrary,
  songs,
  setSongs,
  setCurrentSong,
  isPlaying,
  setIsPlaying,
  timeUpdateHandler,
  currentSong,
  audioRef,
  setAutoPlay,
  autoPlay,
  setIsLoading,
}) {
  const [isActive, setIsActive] = useState(true);

  const toggleClass = () => {
    setIsActive(!isActive);
  };
  return (
    <div
      className={`library invisible md:visible w-[30%] fixed right-0 top-24 text-[#0d0f17] dark:text-[#FFFFFF] rounded-l-xl h-[70%] flex flex-col items-center dark:bg-[#0d0f17] bg-[#fce168] gap-y-10 ease-in-out duration-300 overflow-y-scroll scroll-smooth  ${
        renderLibrary ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="text-2xl fixed top-3 left-[37%] ">Library</div>
      <div className="flex gap-x-3 p-1 fixed top-16 left-[33%] ">
        <span className="text-base text-slate-700 ">Autoplay</span>
        <label
          className="bg-[#FFFFFF] relative h-6 w-12 rounded-full cursor-pointer"
          htmlFor="check"
        >
          <input
            type="checkbox"
            className="sr-only peer"
            name=""
            id="check"
            checked={isActive}
            onChange={() => {
              toggleClass();
              setAutoPlay(!autoPlay);
            }}
          />
          <span className="bg-slate-600 rounded-full h-[75%] w-[40%] absolute left-1 top-[0.20rem] peer-checked:bg-[#0d0f17]  peer-checked:left-[1.6rem] transition-all duration-300 "></span>
        </label>
      </div>
      <div className="library-songs dark:bg-[#141824] bg-[#EBEBD3] rounded-lg p-2 h-[68%] mt-28 overflow-scroll hover:overflow-x-hidden no-scrollbar">
        <div className="library-song">
          {songs.map((song) => (
            <LibrarySong
              key={song.id}
              id={song.id}
              song={song}
              setCurrentSong={setCurrentSong}
              isPlaying={isPlaying}
              setIsPlaying={setIsPlaying}
              timeUpdateHandler={timeUpdateHandler}
              currentSong={currentSong}
              audioRef={audioRef}
              songs={songs}
              setSongs={setSongs}
              setIsLoading={setIsLoading}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
